import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { InviteNewMember } from './members-tab-content-components/InviteNewMember/InviteNewMember';
import { MembersTable } from './members-tab-content-components/MembersTable/MembersTable';

export const MembersTabContent: React.FC = () => {
  return (
    <Stack direction="column" divider={<Divider sx={{ marginY: '20px' }} />} sx={{
      paddingY: "20px"
    }}>
      <Stack
        direction="column"
        sx={{
          display: "flex",
          paddingX: "20px"
        }}>
        <Typography variant="h6">Members Management</Typography>
        <Typography variant="subtitle1" sx={{
          color: "text.secondary"
        }}>
          Manage your team members here
        </Typography>
      </Stack>
      <InviteNewMember />
      <MembersTable />
    </Stack>
  );
};
